var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.1641V21.3641C8.5 21.6441 8.5 21.7841 8.4455 21.8911C8.39757 21.9851 8.32108 22.0616 8.227 22.1096C8.12004 22.1641 7.98003 22.1641 7.7 22.1641H5.8C5.51997 22.1641 5.37996 22.1641 5.273 22.1096C5.17892 22.0616 5.10243 21.9851 5.0545 21.8911C5 21.7841 5 21.6441 5 21.3641V19.1641M19 19.1641V21.3641C19 21.6441 19 21.7841 18.9455 21.8911C18.8976 21.9851 18.8211 22.0616 18.727 22.1096C18.62 22.1641 18.48 22.1641 18.2 22.1641H16.3C16.02 22.1641 15.88 22.1641 15.773 22.1096C15.6789 22.0616 15.6024 21.9851 15.5545 21.8911C15.5 21.7841 15.5 21.6441 15.5 21.3641V19.1641M3 12.1641H21M3 5.66406H21M6.5 15.6641H8M16 15.6641H17.5M7.8 19.1641H16.2C17.8802 19.1641 18.7202 19.1641 19.362 18.8371C19.9265 18.5495 20.3854 18.0905 20.673 17.526C21 16.8843 21 16.0442 21 14.3641V6.96406C21 5.2839 21 4.44383 20.673 3.80209C20.3854 3.2376 19.9265 2.77866 19.362 2.49104C18.7202 2.16406 17.8802 2.16406 16.2 2.16406H7.8C6.11984 2.16406 5.27976 2.16406 4.63803 2.49104C4.07354 2.77866 3.6146 3.2376 3.32698 3.80209C3 4.44383 3 5.2839 3 6.96406V14.3641C3 16.0442 3 16.8843 3.32698 17.526C3.6146 18.0905 4.07354 18.5495 4.63803 18.8371C5.27976 19.1641 6.11984 19.1641 7.8 19.1641Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsIcon);
export default __webpack_public_path__ + "static/media/AssetsIcon.c3905e7163b1956096f063adf9488edb.svg";
export { ForwardRef as ReactComponent };